import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import {
  GET_HIGH_REVIEW_SCORE_USERS,
  GET_RECENT_VIDEO_CALL_FEMALE_USERS,
  UTAGE_WEB_GET_MEET_PEOPLE_EXCLUDE_VIDEO_CALL_CHANNELER,
} from "~/constants/apiEndpoints";
import { APPLICATION_ID } from "~/constants/app";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import type {
  DiscoverUserListResponse,
  HighReviewScoreUsersResponse,
  RecentVideoCallUsersResponse,
} from "./types";

const PAGE_SIZE = 19;

const buildRequestBody = (lastLoginTime: string | undefined) => {
  return {
    limit: PAGE_SIZE,
    sort_type: 0,
    default_avatar_flag: false,
    ...(lastLoginTime !== undefined ? { last_login_time: lastLoginTime } : {}),
  };
};

const RECENT_VIDEO_CALL_LIMIT = 20;

export const recentVideoCallUsersQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.discover.recentVideoCallUsers(),
    queryFn: () =>
      apiClient<RecentVideoCallUsersResponse>(
        GET_RECENT_VIDEO_CALL_FEMALE_USERS,
        {
          application_id: APPLICATION_ID,
          limit: RECENT_VIDEO_CALL_LIMIT,
        },
      ),
    // サーバー側が1時間キャッシュするため、クライアント側も同じ時間を設定
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });

const HIGH_REVIEW_SCORE_LIMIT = 20;

export const highReviewScoreUsersQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.discover.highReviewScoreUsers(),
    queryFn: async () => {
      const users = await apiClient<HighReviewScoreUsersResponse>(
        GET_HIGH_REVIEW_SCORE_USERS,
        { limit: HIGH_REVIEW_SCORE_LIMIT },
      );
      // API によって last_login_time / last_login どちらで返るか不定なため正規化
      return users.map((u) => ({
        ...u,
        last_login_time: u.last_login_time || u.last_login || "",
      }));
    },
    // サーバー側が1時間キャッシュするため、クライアント側も同じ時間を設定
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });

export const discoverUsersInfiniteQueryOptions = () =>
  infiniteQueryOptions({
    queryKey: queryKeys.discover.list(),
    queryFn: ({ pageParam }) =>
      apiClient<DiscoverUserListResponse>(
        UTAGE_WEB_GET_MEET_PEOPLE_EXCLUDE_VIDEO_CALL_CHANNELER,
        buildRequestBody(pageParam),
      ),
    initialPageParam: undefined as string | undefined,
    // この API はサーバー側でビデオ通話チャンネラーを除外するため、続きがあっても
    // 1 ページが PAGE_SIZE 未満で返ることがある。件数で打ち切るとそこで止まるので、
    // カーソル (last_login_time) の有無だけで判定する。空ページ＝最終要素なしで終端。
    getNextPageParam: (lastPage) => lastPage.at(-1)?.last_login_time,
  });
